<template>
  <el-row :gutter="10">
    <el-col :span="9">
      <page-tree-table />
    </el-col>
    <el-col :span="15">
      <page-list-table />
    </el-col>
  </el-row>
</template>
<script>
import PageTreeTable from './components/tree-table'
import PageListTable from './components/list-table'
export default {
  name: 'sample-sampleInputTemplate',
  components: {
    PageTreeTable,
    PageListTable,
  },
  data() {
    return {}
  },
  mounted() {},
}
</script>
